"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossiblePropertyPolicySchema = void 0;
const zod_1 = require("zod");
const HouseholdMember_1 = require("./HouseholdMember");
const PropertyDetails_1 = require("./PropertyDetails");
const PropertyPolicyHolder_1 = require("./PropertyPolicyHolder");
const PropertyCoverage_1 = require("./PropertyCoverage");
const PropertyMortgage_1 = require("./PropertyMortgage");
const Policy_1 = require("./Policy");
const PropertyDiscount_1 = require("./PropertyDiscount");
exports.impossiblePropertyPolicySchema = Policy_1.impossiblePolicySchema.extend({
    policyHolder: PropertyPolicyHolder_1.impossiblePropertyPolicyHolderSchema.optional(),
    householdMembers: zod_1.z.nullable(zod_1.z.array(HouseholdMember_1.impossibleHouseholdMemberSchema)).optional(),
    property: PropertyDetails_1.impossiblePropertyDetailsSchema.optional(),
    coverages: zod_1.z.nullable(zod_1.z.array(PropertyCoverage_1.impossiblePropertyCoverageSchema).min(1)).optional(),
    mortgages: zod_1.z.nullable(zod_1.z.array(PropertyMortgage_1.impossiblePropertyMortgageSchema)).optional(),
    discounts: zod_1.z.array(PropertyDiscount_1.impossiblePropertyDiscountSchema).optional(),
}).strict();
